import { motion } from "framer-motion";
import { featured } from "@/data/portfolio";
import { ArrowUpRight, Folder } from "lucide-react";

export default function Featured({ onOpen }) {
  return (
    <section id="work" className="section featured" data-testid="featured-section">
      <header className="section__head">
        <span className="overline">◆ Featured · {String(featured.length).padStart(2, "0")} selected works</span>
        <h2 className="section__title serif" data-testid="featured-heading">
          The work, <span className="italic">up&nbsp;front.</span>
        </h2>
        <p className="section__lede">
          Signature projects — placed deliberately at the top, so what matters lands first.
        </p>
      </header>

      <div className="featured__grid">
        {featured.map((project, i) => (
          <FeaturedCard
            key={project.id}
            project={project}
            onOpen={onOpen}
            index={i}
          />
        ))}
      </div>
    </section>
  );
}

function FeaturedCard({ project, onOpen, index }) {
  return (
    <motion.button
      type="button"
      initial={{ opacity: 0, x: -16 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1], delay: index * 0.07 }}
      onClick={() => onOpen(project)}
      className="fcard"
      data-testid={`featured-card-${project.id}`}
      aria-label={`Open case study: ${project.title}`}
    >
      {/* Accent-coloured folder icon */}
      <span className="fcard__icon" aria-hidden>
        <Folder size={36} strokeWidth={1.1} />
      </span>

      {/* Category label + Recently Added tag */}
      <span className="fcard__label">
        <span className="overline">{project.category} · {project.year}</span>
        {index === 0 && <span className="fcard__recent">Recently Added</span>}
      </span>

      {/* Dashed separator */}
      <span className="fcard__sep" aria-hidden />

      {/* Project title */}
      <h3 className="fcard__title serif">{project.title}</h3>

      {/* Dashed separator */}
      <span className="fcard__sep" aria-hidden />

      {/* CTA pill */}
      <span className="fcard__cta">
        View Case
        <ArrowUpRight size={13} strokeWidth={2.2} aria-hidden />
      </span>
    </motion.button>
  );
}
